<app-toolbar
  [menuIsOpen]="menuIsOpen$"
  [phoneNumber]="phoneNumber$"
  (clickedCheckPrices)="handleClickedCheckPrices(); scrollToTop()"
  (clickedHeaderItem)="
    sendEvent('header item click', {
      button: 'step',
      $event
    })
  "
  (clickedMenuItem)="sendEvent('menu item click', $event)"
  (clickedMouraFacilBrand)="handleClickedMouraFacilBrand()"
  (clickedPhone)="
    sendEvent('click phone', {
      clicked_phone: 'header',
      phone_number: phoneNumber$
    })
  "
  (menuToggled)="handleMenuToggled($event)"
/>

<router-outlet />

<app-baseboard
  (clickedMenuItem)="sendEvent('footer item click', $event)"
  (clickedSocialItem)="sendEvent('social item click', $event)"
/>

<app-floating
  [menuIsOpen]="menuIsOpen$"
  [renderCheckPrices]="renderCheckPrices$"
  [whatsAppCTAIsAbove]="whatsAppCTAIsAbove$"
  [phoneNumber]="phoneNumber$"
  [whatsAppWelcome]="whatsAppWelcome$"
  (clickedOrderNow)="
    sendEvent('click phone', {
      button: 'phone - mobile',
      clicked_phone: 'floating',
      phone_number: phoneNumber$
    })
  "
  (clickedOrderYourBattery)="handleClickedCheckPrices(); scrollToTop()"
  (clickedWhatsApp)="sendEvent('click floating whatsapp')"
/>

<app-spinning [show]="showSpinning$" />

<app-dialog-battery-unavailable
  [selectedBattery]="selectedBattery$"
  [selectedCity]="selectedCity$"
  [selectedVehicle]="selectedVehicle$"
  [show]="showDialogBatteryUnavailable$"
  (selectAnotherCity)="handleSelectAnotherCity()"
  (searchRetailer)="handleSearchRetailer()"
/>

<app-dialog-city-inactive
  [selectedCity]="selectedCity$"
  [show]="showDialogCityInactive$"
  (selectAnotherCity)="handleSelectAnotherCity()"
  (searchRetailer)="handleSearchRetailer()"
/>

<app-dialog-city-unavailable
  [selectedCity]="selectedCity$"
  [show]="showDialogCityUnavailable$"
  (selectAnotherCity)="handleSelectAnotherCity()"
  (searchRetailer)="handleSearchRetailer()"
/>

<app-dialog-complex-exchange
  [selectedVehicle]="selectedVehicle$"
  [show]="showDialogComplexExchange$"
  (close)="handleCloseDialogComplexExchange()"
  (searchRetailer)="handleSearchRetailer()"
/>

<app-dialog-service-unavailable
  [show]="showDialogServiceUnavailable$"
  (close)="handleCloseDialogServiceUnavailable()"
  (talkViaPhone)="handleTalkViaPhone()"
/>
